import type { ReactElement } from "react";
import { SectionTag, type SectionTagProps } from "@/shared/components";
import { cn } from "@/lib/utils";

interface HeroTagsRowProps {
  tags: string[];
  variant?: SectionTagProps["variant"];
  className?: string;
}

/** Ряд tag-lite над заголовком hero: gap 24px между тегами (Figma). */
export function HeroTagsRow({
  tags,
  variant = "default",
  className,
}: HeroTagsRowProps): ReactElement | null {
  if (!tags.length) {
    return null;
  }

  return (
    <div className={cn("flex flex-wrap items-center gap-6", className)}>
      {tags.map((label, index) => (
        <SectionTag
          key={`${label}-${index}`}
          label={label}
          variant={variant}
          className="text-xs md:text-base [&>span:first-child]:size-1 md:[&>span:first-child]:size-1.5"
        />
      ))}
    </div>
  );
}
